import React, { useContext, useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";
import { Button, Dialog } from "iuvity-ui-components";
import { MultiSelect } from "primereact/multiselect";
import { DialogProps } from "../dialog/CustomDialog";
import { AppContext } from "../../context/index";
import { TranslationsSchema } from "../../validations/schemas";
import { REVALIDATE_FORM_PROPS } from "../../constants";

interface FilterDialogProps extends DialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  onClearFilters: Function;
  form: any;
  formOptions: any;
}

export const FilterDialog: React.FC<FilterDialogProps> = ({
  visible,
  setVisible,
  data,
  setData,
  onClearFilters,
  form,
  formOptions,
}) => {
  const { t } = useContext(AppContext);
  const { control, setValue, getValues, reset } = form;

  const functionalityValues = useWatch({
    control: form.control,
    name: "functionality",
  });

  const typesValues = useWatch({
    control: form.control,
    name: "type",
  });

  const languagesValues = useWatch({
    control: form.control,
    name: "translationlanguage",
  });

  const onCloseModal = () => {
    setVisible(false);
  };

  const onFilter = () => {
    const formValues = getValues();
    setData(
      data.filter(
        (item: any) =>
          (functionalityValues.length > 0
            ? item.functionality.some(
                (wid: any[]) => functionalityValues.indexOf(wid) !== -1
              )
            : true) &&
          (typesValues.length > 0 ? typesValues.includes(item.type) : true) &&
          (languagesValues.length > 0
            ? languagesValues.includes(item.translationlanguage)
            : true)
      )
    );
    reset(formValues);
  };

  const handleFilter = () => {
    onFilter();
    setVisible(false);
  };

  useEffect(() => {
    if (data) {
      onFilter();
    } else {
      setData(null);
    }
  }, [data, setData]);

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          className="mr-4"
          label={t("ConsoleTranslations.clearFilterBtnLabel")}
          variant="p-button-link"
          onClick={() => onClearFilters()}
        />
        <Button
          label={t("ConsoleTranslations.filterBtnLabel2")}
          variant="p-button"
          disabled={
            !(
              functionalityValues.length > 0 ||
              typesValues.length > 0 ||
              languagesValues.length > 0
            )
          }
          onClick={handleFilter}
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1T"
      className="dialog-form"
      header={t("ConsoleTranslations.filterDialogTitle")}
      visible={visible}
      onHide={onCloseModal}
      style={{ width: "35rem" }}
      footer={renderFooter}
    >
      <div className="form lg">
        {["functionality", "type", "translationlanguage"].map((key) => {
          return (
            <div key={key}>
              <Controller
                name={key}
                control={control}
                rules={(TranslationsSchema(t) as any)[key]}
                render={({ field }) => {
                  field.onChange = (e) => {
                    setValue(field.name, e.value, REVALIDATE_FORM_PROPS);
                  };
                  return (
                    <>
                      <label htmlFor={key} className="block lb mt-2 mb-1">
                        {t(`ConsoleTranslations.${key}Label`)}
                      </label>
                      <MultiSelect
                        id={`select-widget`}
                        display="chip"
                        placeholder={t(
                          `ConsoleTranslations.${key}PlaceholderFilterLabel`
                        )}
                        className="mb-4"
                        options={formOptions[key]}
                        filter
                        emptyFilterMessage={t(
                          "ConsoleTranslations.noAvailableMessage"
                        )}
                        {...field}
                      />
                    </>
                  );
                }}
              />
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};
